export const TAB_KEYS = {
    ATTACHMENTS: 'attachments',
    COMMENTS: 'comments',
    EDIT: 'edit' // This is default tab
}

export const COOKIE_KEY = 'INQUIRY_CURRENT_TAB'
